<template>
  <settings-card :config="config">
    <el-button
      type="text"
      @click="settings">去设置</el-button>
    <subject-modal ref="modal" />
  </settings-card>
</template>
<script>
import SettingsCard from '../../../appraisal/base/busi/settings-card.vue'
import SubjectModal from './subject-modal.vue'
export default {
  name: 'SubjectCard',
  components: { SettingsCard, SubjectModal },
  props: {
    config: { type: Object, default() { return {} } }
  },
  methods: {
    settings() {
      this.$refs.modal.fetch()
    }
  }
}
</script>
